import { INTEGRATION_CODE_INSALES } from '../../../../common/constants';
import { InSalesLogo, InSalesSmallLogo } from './InSalesLogo';

export default {
  code: INTEGRATION_CODE_INSALES,
  logo: InSalesLogo,
  small_logo: InSalesSmallLogo,
};
